import { useAsync } from "@/shared/hooks/HookBase";
import { useCallback } from "react";
import type IUserSettingService from "../contracts/IUserSettingService";
import UserSettingService from "../services/UserSettingService";

const userSettingService: IUserSettingService = new UserSettingService();

export function useUserSettings() {
  const { loading, error, execute } = useAsync();

  const getKeys = useCallback(async () => {
    return await execute(() => userSettingService.getKeys());
  }, [execute]);

  const get = useCallback(async (key: number): Promise<string> => {
    return await userSettingService.get(key);
  }, []);

  const set = useCallback(
    async (key: number, newValue: string): Promise<void> => {
      await userSettingService.set(key, newValue);
    },
    [],
  );

  return {
    loading,
    error,
    getKeys,
    get,
    set,
  };
}
